module.exports = __webpack_public_path__ + "media/components/assets/img/bg/header-b4b3d75fd577904cdb18c10947e87856.png";